<template>
	<div id="main">
		<!-- <img src="../../assets/logo.png" /> -->
		<div class="text-left" style="line-height: 40px;padding-left: 20px;">数据更新时间 ：{{ updateTime() }}</div>
		<div class="text-left" style="line-height: 40px;padding-left: 20px;">
			<div>系统类型及版本号：<span class="phpinfo">{{data.php_uname}}</span></div>
			<div>系统运行方式：<span class="phpinfo">{{data.php_sapi_name}}</span></div>
			<div>PHP版本：<span class="phpinfo">{{data.php_version}}</span></div>
			<div>Zend版本：<span class="phpinfo">{{data.zend_version}}</span></div>
			<div>登录ip：<span class="phpinfo">{{data.ip}}</span></div>
			<div>当前管理员身份：<span class="phpinfo">{{data.manage_group}}</span></div>
		</div>
		<div class="increase">
			<div>
				<div class="icondiv" :style="'background:rgba' + rgb()"><i class="el-icon-document"></i></div>
				<div class="increaseData" @click="topage('/document')">
					<p>内容管理</p>
				</div>
			</div>
			<div>
				<div class="icondiv" :style="'background:rgba' + rgb()"><i class="el-icon-link"></i></div>
				<div class="increaseData" @click="topage('/friendLink')">
					<p>友链管理</p>
				</div>
			</div>
			<div>
				<div class="icondiv" :style="'background:rgba' + rgb()"><i class="el-icon-s-comment"></i></div>
				<div class="increaseData" @click="topage('/BBSModule')">
					<p>留言管理</p>
				</div>
			</div>
			<div>
				<div class="icondiv" :style="'background:rgba' + rgb()"><i class="el-icon-menu"></i></div>
				<div class="increaseData" @click="topage('/languageManage')">
					<p>多语言管理</p>
				</div>
			</div>
			<div>
				<div class="icondiv" :style="'background:rgba' + rgb()"><i class="el-icon-info"></i></div>
				<div class="increaseData" @click="topage('/logRecord')">
					<p>操作日志</p>
				</div>
			</div>
			<div>
				<div class="icondiv" :style="'background:rgba' + rgb()"><i class="el-icon-setting"></i></div>
				<div class="increaseData" @click="topage('/Setting')">
					<p>系统设置</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	name:'home',
	data() {
		return {
			data: {
				data:{
					php_uname:'',
					php_sapi_name:'',
					php_version:'',
					zend_version:'',
					ip:'',
					manage_group:'',
				}
			}
		};
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		// 数据统计
		baseinfo() {
			this.$axios({
				url: this.HOST + '/admin.index/baseinfo',
				method: 'POST',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						console.log(res.data);
						this.data = res.data.info;
					}
				})
				.catch(err => {});
		},
		rgb() {
			//rgb颜色随机
			var r = Math.floor(Math.random() * 256);
			var g = Math.floor(Math.random() * 256);
			var b = Math.floor(Math.random() * 256);
			var rgb = '(' + r + ',' + g + ',' + b + ')';
			console.log(rgb);
			return rgb;
		},
		topage(page){
			this.$router.push(page);
		},
		updateTime(){
			var ctime = new Date().getTime();
			if (ctime) {
				var date = new Date(ctime);
				var h = date.getHours() < 10 ? '0' + date.getHours() : String(date.getHours());
				console.log(h);
				var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
				var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
				var createTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + h + ':' + m + ':' +
					s;
				return createTime;
			} else {
				return '';
			}
		},
	},
	mounted() {
		console.log('router.id:', this.$route.params.id);
		// 调用绘制图表的方法
		// this.statistics();
		this.baseinfo();
	}
};
</script>

<style>
.increase {
	display: flex;
	justify-content: flex-start;
	flex-flow: row wrap;
	padding: 15px;
}
.increase > div {
	width: 30%;
	margin-right: 3%;
	display: flex;
	box-shadow: 0 0 15px #eee;
	margin-bottom: 30px;
}
.icondiv {
	padding: 35px 25px;
	color: #fff;
	font-size: 30px;
}
.increaseData {
	padding: 25px;
	cursor: pointer;
}
.charts {
	display: flex;
	justify-content: space-between;
	flex-flow: row wrap;
}
.echart {
	width: 30%;
	min-width: 300px;
	height: 300px;
	margin: 20px auto;
	border: 1px solid #ccc;
}
.bigtext {
	font-size: 30px;
}
.phpinfo{
	color: #0063c6;
	padding: 0 15px;
}
</style>
